export enum LocalStorageKey {
  // Session keys get cleared when the user logs out
  SESSION_GOOGLE_AUTH_ATTEMPT = 'googleAuthAttempt',
  SESSION_INTUIT_AUTH_ATTEMPT = 'intuitAuthAttempt',
  SESSION_MICROSOFT_AUTH_ATTEMPT = 'microsoftAuthAttempt',
  SESSION_ONBOARDING_EMAIL = 'onboardingEmail',
  SESSION_USER_ACTIVITY_TIMESTAMP_KEY = 'lastTimeUserActiveMs',
  SESSION_CONNECTED_ACCOUNTING = 'connected_accounting',
  SESSION_CONNECTED_PAYROLL = 'connected_payroll',
  SESSION_ON_ERROR_RELOAD_STATE = 'ON_ERROR',
  SESSION_LOGIN_METHOD = 'loginMethod',
  // Persisted keys never get cleared
  PERSIST_ENTERPRISE_SSO_PROVIDER_ID = 'enterpriseSsoProviderId',
  PERSIST_IP_WHITELIST_ERROR = 'ipWhitelistError',
}
